import React, { useState } from 'react'
import { Text, View } from 'react-native'
import { BackHeader } from '../../../../assets/icons'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { useTheme } from 'react-native-paper'
import { useResponsive } from '../../../../utils/hooks'
import { ProjectInvoices } from './ProjectInvoices'
import { ProjectSummary } from './ProjectSummary'
import { CustomHeader, HEADER_HEIGHT } from '../../../../ui/atoms/CustomHeader'
import { useNavigation } from '@react-navigation/core'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import Wrapper from '../../Wrapper'
import { paths } from '../../../links'
import { useTranslation } from 'react-i18next'

const backBehavior = (navigation) => {
  navigation.navigate(paths.Console.Projects.List)
}

const ProjectDetailsHeader = ({ project }) => {
  const { t } = useTranslation('global')
  const navigation = useNavigation()
  return (
    <View
      style={{
        height: HEADER_HEIGHT,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        borderBottom: '1px solid #F5F7F8',
      }}
    >
      <GetIcon
        icon={<BackHeader height="16" width="16" />}
        onPress={() => backBehavior(navigation)}
      />
      <View style={{ alignItems: 'center' }}>
        <Text style={{ fontWeight: '500', fontSize: 12 }}>
          {t('Projects.projects')}
        </Text>
        <Text
          style={{
            fontWeight: '500',
            fontSize: 16,
            color: commonColors.accentText,
          }}
        >
          {project.name}
        </Text>
      </View>
      <View style={{ width: 40 }}></View>
    </View>
  )
}

const Tab = createMaterialTopTabNavigator()

const TOP_TAB_NAVIGATOR_HEIGHT = 39

export const ProjectDetailsContext = React.createContext({
  project: {},
  setProjectInvoices: () => {},
  projectInvoices: [],
})

export const ProjectDetails = ({ route }) => {
  const { project } = route.params
  const { t } = useTranslation('global')
  const { accentText } = useTheme().colors
  const { screenWidth } = useResponsive()

  const [projectInvoices, setProjectInvoices] = useState([])

  return (
    <Wrapper toolbar={<ProjectDetailsHeader project={project} />}>
      <ProjectDetailsContext.Provider
        value={{ project: project, projectInvoices, setProjectInvoices }}
      >
        <Tab.Navigator
          headerMode="screen"
          initialRouteName={paths.Console.Projects.Summary}
          initialLayout={{ width: screenWidth }}
          tabBarOptions={{
            //create separate file for these later
            activeTintColor: accentText,
            inactiveTintColor: '#335C75',
            indicatorStyle: {
              backgroundColor: 'white',
              height: 33,
              marginVertical: 3,
              width: '48%',
              marginHorizontal: 3,
              borderRadius: 8,
            },
            //create separate file for style later
            style: {
              backgroundColor: '#F4F9FD',
              height: TOP_TAB_NAVIGATOR_HEIGHT,
              borderRadius: 8,
              marginTop: 10,
              marginBottom: 15,
              justifyContent: 'center',
              marginHorizontal: 16,
            },
          }}
          screenOptions={({ route }) => ({
            tabBarLabel: ({ tintColor, focused, item }) => {
              return focused ? (
                <Text
                  style={{
                    fontWeight: '600',
                    fontSize: 14,
                    color: accentText,
                    width: 178,
                    textAlign: 'center',
                  }}
                >
                  {route.name === paths.Console.Projects.Invoices
                    ? t('Projects.invoices')
                    : t('Projects.details')}
                </Text>
              ) : (
                <Text
                  style={{
                    fontWeight: '500',
                    fontSize: 14,
                    color: '#335C75',
                    width: 178,
                    textAlign: 'center',
                  }}
                >
                  {route.name === paths.Console.Projects.Invoices
                    ? t('Projects.invoices')
                    : t('Projects.details')}
                </Text>
              )
            },
            header: CustomHeader,
          })}
          swipeEnabled={false}
        >
          <Tab.Screen
            name={paths.Console.Projects.Invoices}
            component={ProjectInvoices}
          />
          <Tab.Screen
            name={paths.Console.Projects.Summary}
            component={ProjectSummary}
          />
        </Tab.Navigator>
      </ProjectDetailsContext.Provider>
    </Wrapper>
  )
}
